import { AiQuestion } from '~api/ai/types';
import nanoid from 'nanoid';

// Helper to add unique id to questions
export const addQuestionIds = (questions: AiQuestion[]) => {
  return questions.map((question) => ({
    ...question,
    questionId: nanoid(),
  }));
};
